import { ui } from '@beelday/common'
import { useSelector } from 'react-redux'
import { SlideRenderer } from 'slides/slide-renderer'
import { selectActiveSlideId } from './slide-redux'

export const ConfiguredSlideViewer = (): JSX.Element => {
	const slideId = useSelector(selectActiveSlideId)
	return slideId ? <SlideRenderer slideId={slideId} /> : <ui.FullPageSpinner />
}

export default ConfiguredSlideViewer
